import axios from 'axios'
import { ElMessage } from 'element-plus'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // 从环境变量获取API基础URL
  timeout: 10000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 例如：添加请求头、身份验证令牌等
    
    // 添加必要的请求头
    // config.headers['Content-Type'] = 'application/json'
    // config.headers['Accept'] = 'application/json'
    // config.headers['X-Requested-With'] = 'XMLHttpRequest'
    
    // 可以在这里添加loading状态
    
    return config
  },
  error => {
    // 处理请求错误
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data
    
    // 根据后端返回的状态码或状态标志进行处理
    if (res.success === false) {
      ElMessage.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    
    return res
  },
  error => {
    // 处理响应错误
    console.error('Response error:', error)
    
    // 根据HTTP状态码处理错误
    const status = error.response?.status
    let message = '请求失败'
    
    if (status === 400) {
      message = '请求参数错误'
    } else if (status === 401) {
      message = '未授权，请重新登录'
    } else if (status === 403) {
      message = '拒绝访问'
    } else if (status === 404) {
      message = '请求的资源不存在'
    } else if (status === 500) {
      message = '服务器内部错误'
    } else if (error.message.includes('timeout')) {
      message = '请求超时'
    } else if (error.message.includes('Network Error')) {
      message = '网络错误，请检查您的网络连接'
    }
    
    ElMessage.error(message)
    return Promise.reject(error)
  }
)

export default service